/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Quick_Navigation_TitleInputs */

const en_inventory_quick_navigation_title = /** @type {(inputs: Inventory_Quick_Navigation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Navigation`)
};

const es_inventory_quick_navigation_title = /** @type {(inputs: Inventory_Quick_Navigation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegacion rapida`)
};

/**
* | output |
* | --- |
* | "Quick Navigation" |
*
* @param {Inventory_Quick_Navigation_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_quick_navigation_title = /** @type {((inputs?: Inventory_Quick_Navigation_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Quick_Navigation_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_quick_navigation_title(inputs)
	return es_inventory_quick_navigation_title(inputs)
});